export const reduxKey = '@@ResourceCache';

//# sourceMappingURL=constants.js.map